import React, { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useGetResultQuery, useSendReportToEmailMutation } from "../../../generated-types"
import { Box, Button, Form, Heading, Menu, Text } from "grommet"
import { EmailField } from "../../login/EmailField"
import { useTranslation } from "react-i18next"
import DiagLayout from "../../../components/DiagLayout"
import { ToastsStore } from "react-toasts"
import { REPORT_LANG_LABELS, reportLangsOf } from "./ReportUtil"
import { useLanguageContext } from "../../../components/context/LanguageContext"

export const ResultReportPage: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { paperId, pgmId } = useParams()
  const { lang: uiLang } = useLanguageContext()
  // 진단 항목별로 실제 템플릿이 있는 언어만 노출하고, 기본값은 현재 화면 언어를 따른다.
  const availableLangs = reportLangsOf(pgmId)
  const uiBaseLang = (uiLang || "").split("-")[0].toLowerCase()
  const [lang, setLang] = useState(availableLangs.includes(uiBaseLang) ? uiBaseLang : availableLangs[0])
  const [processing, setProcessing] = useState(false)
  const { loading, error } = useGetResultQuery({ variables: { paperId } })
  const [sendReportToEmail] = useSendReportToEmailMutation({})
  if (loading) return null
  if (error) {
    return <div>{error.message}</div>
  }

  const languages = availableLangs.map((value) => ({
    value,
    label: REPORT_LANG_LABELS[value] || value,
    onClick: () => setLang(value),
  }))

  const sendReport = (form) => {
    const { email } = form
    setProcessing(true)
    sendReportToEmail({ variables: { paperId, lang, email } })
      .then((r) => {
        if (r.data) {
          ToastsStore.success("Send report completed!")
        }
      })
      .catch(() => {
        ToastsStore.error("Failed to send report!")
      })
      .finally(() => setProcessing(false))
  }

  return (
    <DiagLayout>
      <Heading level={2} style={{ marginBottom: "0.4em" }}>
        {t("label.result-report-title")}
      </Heading>
      <Text size="18px" color="#777777" style={{ margin: 0 }}>
        {t("label.result-report-desc")}
      </Text>
      <Box justify="center" width="medium" pad="small">
        <Form onSubmit={(e) => sendReport(e.value)}>
          <Box margin={{ vertical: "medium" }}>
            <EmailField field="email" label="please-input-email" />
            <label style={{ margin: "auto" }}>
              🌐
              <Menu
                items={languages}
                margin={{ left: "small" }}
                label={languages.find((l) => l.value === lang)?.label || lang}
              />
            </label>
          </Box>
          <Box direction="row" justify="stretch" gap="small">
            <Button
              type="button"
              label={t("button.cancel")}
              fill="horizontal"
              color="#C02026"
              onClick={() => navigate(-1)}
            />
            <Button
              type="submit"
              label={t("button.send")}
              disabled={processing}
              primary
              fill="horizontal"
              color="#C02026"
            />
          </Box>
        </Form>
      </Box>
    </DiagLayout>
  )
}
